import * as React from 'react'

import { Box, Text, colors } from '@factorialco/deprecated-design-system'
import { ResponsiveBar } from '@nivo/bar'

import { observer } from 'mobx-react'

import type ScoreForm from 'modules/reviews/components/Analytics/ScoreResults/ScoreForm'
// TODO: using private components from another page
import { useData, useKeys } from 'modules/reviews/components/Analytics/ScoreResults/hooks'
import { useAnalytics } from 'modules/reviews/pages/performance/Show/Analytics/analyticsContext'
import type AnalyticResult from 'modules/reviews/store/models/AnalyticResult'

import BottomTick from './BottomTick'

interface Props {
  analyticResult: AnalyticResult
  scoreForm: ScoreForm
  title: string
}

const BarChart = ({ analyticResult, scoreForm, title }: Props) => {
  const { cycle } = useAnalytics()
  const questionGroups = analyticResult.questionGroupsInCycle(cycle)
  const { data: heatmapData } = useData(analyticResult, scoreForm, questionGroups).get()
  const keys = useKeys(analyticResult, scoreForm).get()

  const data = keys.map((key, index) => ({
    question: key,
    value: heatmapData[0] && heatmapData[0][(index + 1).toString() + '. ' + key],
  }))

  const borderStyle = {
    color: 'grey400',
    width: 's1',
    style: 'solid',
  } as const

  return (
    <Box
      border={{
        all: borderStyle,
      }}
    >
      <Box
        border={{
          bottom: borderStyle,
        }}
        borderRadius={{
          topRight: 'abs008',
          topLeft: 'abs008',
        }}
        paddingY="s16"
        paddingX="s24"
        background="grey200"
      >
        <Text.Normal weight="medium">{title}</Text.Normal>
      </Box>
      <Box
        style={{
          height: '600px',
        }}
      >
        <ResponsiveBar
          data={data}
          indexBy="question"
          borderRadius={2}
          padding={0.3}
          innerPadding={3}
          colors={colors.champagne1000}
          minValue="auto"
          maxValue="auto"
          margin={{
            top: 100,
            right: 100,
            bottom: 100,
            left: 100,
          }}
          axisBottom={{
            tickSize: 0,
            renderTick: BottomTick,
          }}
          axisLeft={{
            tickSize: 0,
            tickPadding: 50,
          }}
        />
      </Box>
    </Box>
  )
}

export default observer(BarChart)
